const wysiwyg = (postType) => (`
    ... on ${postType}_Components_Components_Wysiwyg {
        fieldGroupName
        content
        cta {
            target
            title
            url
        }
        inlineForm {
            showInlineForm
            hubspotFormId
            formTitle
            hideEventInformation
        }
        settings {
            theme
            showSharingLinks
            showTags
            showComponentTitle
            componentTitle
            spacing
        }
    }
`
);

export default wysiwyg;
